<script setup lang="ts">
import { useCompanyStore } from '@Stores/company.store';
import { useLocationStore } from '@Stores/location.store';
import { ShowcaseLayout } from '@Shared';
import useCompanyImageBaseUrl from '@Src/use/useCompanyImageBaseUrl';
import ShowcaseImage from '@Components/ShowcaseImage.vue';

const companyStore = useCompanyStore();
const locationStore = useLocationStore();
const companyImageBaseUrl = useCompanyImageBaseUrl();

</script>

<template>
    <showcase-layout
        title="You've declined this request"
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl"
        show-powered-by>

        <template #mobileAccent>
            <div class="esignature-decline-candy">
                <img
                    class="esignature-decline-candy__image"
                    :src="'/images/esignature/secure-signing.svg'"
                />
            </div>
        </template>

        <template #branded>
            <showcase-image />
        </template>

        <app-form-content-layout>
            <div class="success-content">
                <p>
                    We've let your closing team know. The document is now closed.
                    <br />
                    <br />
                    If you declined by mistake or need to make changes, contact your closing team to request a new version.
                </p>
            </div>
        </app-form-content-layout>
    </showcase-layout>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.esignature-decline-candy {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;

    &__image {
        max-width: 11.6875rem;
        max-height: 11rem;

        @include desktop {
            width: 25rem;
            max-width: none;
            max-height: 21.6875rem;
        }
    }
}
</style>

